<template>
  <Badge
    v-if="defaultPrice"
    class="rebate-badge text--bold"
    :magenta="magenta"
    :white="white"
    :black="black"
    :style="customStyle"
    :bold="bold"
  >
    <span
      v-if="preText"
      class="rebate-badge__pre-text"
      v-html="preText"
    />
    <span class="rebate-badge__text">
      {{ humanizePriceFromCents(defaultPrice) }}
    </span>
    <br />
    <template v-if="wasPrice && wasPrice > 0">
      statt
      <span class="text--strikethrough">{{ humanizePriceFromCents(wasPrice) }}</span>
    </template>
  </Badge>
</template>

<script setup lang="ts">
import { Badge } from '@i22team/td-longtail-vue-components';
import { humanizePriceFromCents } from '~/lib/price';
export type RebateBadgeProps = {
  defaultPrice?: number;
  wasPrice?: number;
  preText?: string;
  customStyle?: string;
  isMagentaTheme?: boolean;
  black?: boolean;
  magenta?: boolean;
  white?: boolean;
  bold?: boolean;
};

withDefaults(defineProps<RebateBadgeProps>(), {
  defaultPrice: undefined,
  wasPrice: undefined,
  preText: undefined,
  customStyle: undefined,
});
</script>

<style lang="scss">
@use 'assets/base' as *;
.rebate-badge {
  .badge__content {
    @include mq($mq-md) {
      font-size: 1.2em;
      line-height: 1.3em;
    }
  }

  &__text {
    font-size: 1.5em;
    line-height: 1em;
  }
}
</style>
